import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { CELL_SIZE } from "src/grid/constants";
import { useProgram } from "src/program/ProgramContext";
import { Grid } from "src/grid/Grid";
import { GridLocation } from "src/grid/GridLocation";
import { instructionsMap } from "src/program/instructionData";

export const Workspace = observer(function Workspace() {
  const [isCasting, setIsCasting] = useState(false);
  const program = useProgram();

  return (
    <div>
      <div
        style={{ display: "flex", gap: CELL_SIZE / 2, alignItems: "center" }}
      >
        <h2>Workspace</h2>
        <button
          onClick={() => {
            setIsCasting(!isCasting);
          }}
          style={{ height: "fit-content", cursor: "pointer" }}
        >
          {isCasting ? "Abort" : "Cast"}
        </button>
        <button
          onClick={() => program.step()}
          style={{ height: "fit-content", cursor: "pointer" }}
        >
          Step
        </button>
      </div>
      <Grid
        dimensions={program.gridDimensions}
        renderCell={(index) => (
          <div
            key={index}
            style={{
              width: `${CELL_SIZE}px`,
              height: `${CELL_SIZE}px`,
              border:
                program.cursorIndex === index
                  ? "1px solid black"
                  : "1px solid transparent",
            }}
            onClick={() => {
              const location = GridLocation.fromGridIndex(
                index,
                program.gridDimensions
              );
              program.instructions.set(
                location.toHash(),
                instructionsMap[program.selectedPaletteInstruction]
              );
            }}
          >
            <div>{index}</div>
            <div>
              {
                program.instructions.get(
                  GridLocation.fromGridIndex(
                    index,
                    program.gridDimensions
                  ).toHash()
                )?.type
              }
            </div>
          </div>
        )}
      />
    </div>
  );
});
